module.exports = __webpack_public_path__ + "static/media/form_success_logo.690d8a70.svg";